import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@/core/service/auth.service';
import { ActionMenuOverlay } from '@/share/template/button/action-menu-overlay';
import { LayoutService } from '@/layout/service/layout.service';
import { StorageService } from '@/core/service/storage.service';
import { environment } from './environments/environment';

const IS_PAGE_ACTIVE_KEY = `${environment.appKeyPrefix}:isPageActive`;
const IS_RELOADING_KEY = `${environment.appKeyPrefix}:isReloading`;

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ` <router-outlet />`
})
export class AppComponent {
    constructor(
        public router: Router,
        private auth: AuthService
    ) {
        sessionStorage.setItem(IS_PAGE_ACTIVE_KEY, 'true');
    }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
        // Set a temporary flag on refresh
        sessionStorage.setItem(IS_RELOADING_KEY, 'true');
        event.returnValue = ''; // This may be ignored in modern browsers
    }

    @HostListener('window:unload')
    onUnload() {
        if (!sessionStorage.getItem(IS_RELOADING_KEY)) {
            this.auth.callLogout().subscribe((res: any) => {
                console.log('logout', res);
            });
        }
        sessionStorage.removeItem(IS_RELOADING_KEY);
    }
}
